/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AutomatedEmailsSvg from './automated-emails-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AutomatedEmailsSvg {...validProps} />;
}
SvgComponent.iconName = 'automatedEmails';

export const AutomatedEmailsIcon = svgIconWrapper(SvgComponent);
